import * as Yup from "yup";

export const deliveryInfoSchemaGE = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  phone: Yup.string()
    .matches(/^\+995\d{9}$/, "Phone number must be a valid Georgian number")
    .required("Phone number is required"),
});

export const deliveryInfoSchemaUK = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  phone: Yup.string()
    .matches(/^\+44\d{10}$/, "Phone number must be a valid UK number")
    .required("Phone number is required"),
});

export const deliveryInfoSchemaUZ = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  phone: Yup.string()
    .matches(/^\+998\d{9}$/, "Phone number must be a valid Uzbekistan number")
    .required("Phone number is required"),
});

export const deliveryPaymentSchemaUZ = Yup.object().shape({
  cardNumber: Yup.string()
    .matches(/^\d{16}$/, "Card number must be 16 digits")
    .required("Card number is required"),
  expiryDate: Yup.string()
    .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, "Expiry date must be in MM/YY format")
    .required("Expiry date is required"),
  cvv: Yup.string()
    .matches(/^\d{3}$/, "CVV must be 3 digits")
    .required("CVV is required"),
});
